<app-side-menu>
  <div class="vehicle-form-content">
    <div class="row mb-4">
      <div class="col-12">
        <div class="page-header">
          <h1 class="page-title">
            <i class="fas fa-car-side me-3"></i>
            {{ pageTitle }}
          </h1>
          <p class="page-subtitle">{{ isViewMode ? 'Consulta dos dados do veículo e situação em contrato' : 'Preencha os dados do veículo' }}</p>
        </div>
      </div>
    </div>

    <!-- Visualização: status do veículo (cadastro) × situação de locação (contrato B2B/B2C) -->
    <div *ngIf="isViewMode" class="vehicle-status-banner card mb-4">
      <div class="card-body py-3">
        <div class="row g-3 align-items-start">
          <div class="col-md-6">
            <span class="text-muted small text-uppercase d-block mb-1">Situação do Veículo</span>
            <p class="mb-1">
              <span
                class="badge rounded-pill px-3 py-2"
                [ngClass]="getVehicleCadastroStatusBadgeClass()">
                {{ getVehicleCadastroStatusLabel() }}
              </span>
            </p>
          </div>
          <div class="col-md-6">
            <span class="text-muted small text-uppercase d-block mb-1">Situação de locação (contrato)</span>
            <p class="mb-1">
              <span
                class="badge rounded-pill px-3 py-2"
                [ngClass]="isLinkedToRentalContract ? 'bg-warning text-dark' : 'bg-success'">
                {{ getContractRentalSituationLabel() }}
              </span>
            </p>
            <div *ngIf="isLinkedToRentalContract" class="mt-2 small contract-links">
              <span *ngIf="b2BContractId != null" class="d-block">
                <i class="fas fa-file-contract me-1 text-primary"></i>
                Contrato B2B #{{ b2BContractId }}
                <a [routerLink]="['/b2b/contracts', b2BContractId, 'view']" class="ms-2">Abrir contrato</a>
              </span>
              <span *ngIf="b2CContractId != null" class="d-block mt-1">
                <i class="fas fa-file-signature me-1 text-primary"></i>
                Contrato #{{ b2CContractId }}
                <a [routerLink]="['/contracts', b2CContractId, 'view']" class="ms-2">Abrir contrato</a>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="vehicle-form-card">
      <!-- Navegação por abas (padronizada com FormShell) -->
      <app-form-shell
        [tabs]="availableTabs"
        [activeTab]="activeTab"
        (tabChange)="selectTab($event)">
      </app-form-shell>

      <form [formGroup]="form" (ngSubmit)="save()">
        <!-- Tab: Dados do Veículo -->
        <div *ngIf="activeTab === 'vehicle-data'" class="tab-panel">
          <!-- Seção 1: Identificação -->
          <div class="detail-section">
            <h3><i class="fas fa-fingerprint me-2"></i> Identificação</h3>
            <div class="detail-grid">
              <div class="detail-item">
                <label>Placa *</label>
                <input 
                  class="form-control" 
                  formControlName="plateNumber" 
                  placeholder="Ex: ABC1D23" 
                  appPlateMask 
                  maxlength="8"
                  [class.is-invalid]="form.get('plateNumber')?.hasError('invalidPlate') && form.get('plateNumber')?.touched" />
                <div class="invalid-feedback" *ngIf="form.get('plateNumber')?.hasError('invalidPlate') && form.get('plateNumber')?.touched">
                  Formato inválido. Use o padrão Mercosul: ABC1D23
                </div>
              </div>
              <div class="detail-item">
                <label>Chassi *</label>
                <input class="form-control" formControlName="chassisNumber" placeholder="Ex: 9BWZZZZ377VT00421" />
              </div>
              <div class="detail-item">
                <label>Renavam</label>
                <input class="form-control" formControlName="renavam" placeholder="Ex: 12345678901" appNumberMask [decimals]="0" />
              </div>
              <div class="detail-item">
                <label>Ano Modelo *</label>
                <input type="number" class="form-control" formControlName="modelYear" />
              </div>
              <div class="detail-item">
                <label>Ano Fabricação *</label>
                <input type="number" class="form-control" formControlName="manufactureYear" />
              </div>
            </div>
          </div>

          <!-- Seção 2: Características -->
          <div class="detail-section">
            <h3><i class="fas fa-car me-2"></i> Características</h3>
            <div class="detail-grid">
              <div class="detail-item">
                <label>Marca *</label>
                <select class="form-select" formControlName="brand">
                  <option value="">Selecione</option>
                  <option *ngFor="let option of brandOptions" [value]="option.value">{{ option.label }}</option>
                </select>
              </div>
              <div class="detail-item">
                <label>Modelo *</label>
                <input class="form-control" formControlName="model" placeholder="Ex: Golf" />
              </div>
              <div class="detail-item">
                <label>Cor</label>
                <input class="form-control" formControlName="color" placeholder="Ex: Branco" />
              </div>
              <div class="detail-item">
                <label>Combustível</label>
                <input class="form-control" formControlName="fuelType" placeholder="Ex: Flex" />
              </div>
              <div class="detail-item">
                <label>Quilometragem</label>
                <input type="text" class="form-control" formControlName="currentMileage" appNumberMask [decimals]="0" placeholder="Ex: 50.000" />
              </div>
              <div class="detail-item">
                <label>ID do Rastreador</label>
                <input class="form-control" formControlName="trackerId" placeholder="Ex: 123432423" />
              </div>
              <div class="detail-item">
                <label>Tem baú?</label>
                <select class="form-select" formControlName="hasBox">
                  <option [ngValue]="false">Não</option>
                  <option [ngValue]="true">Sim</option>
                </select>
              </div>
              <div class="detail-item">
                <label>Suporte para celular?</label>
                <select class="form-select" formControlName="hasPhoneSupport">
                  <option [ngValue]="false">Não</option>
                  <option [ngValue]="true">Sim</option>
                </select>
              </div>
            </div>
          </div>

          <!-- Seção 3: Propriedade e Aquisição -->
          <div class="detail-section">
            <h3><i class="fas fa-file-contract me-2"></i> Propriedade e Aquisição</h3>
            <div class="detail-grid">
              <div class="detail-item">
                <label>Propriedade *</label>
                <select class="form-select" formControlName="ownershipType">
                  <option value="Próprio">Próprio</option>
                  <option value="Locado">Locado</option>
                  <option value="Financiado">Financiado</option>
                </select>
              </div>
              <div class="detail-item">
                <label>Situação do veículo (cadastro) *</label>
                <div *ngIf="loadingStatuses" class="loading-statuses">
                  <i class="fas fa-spinner fa-spin me-2"></i>
                  Carregando situação...
                </div>
                <select
                  *ngIf="!loadingStatuses"
                  class="form-select"
                  formControlName="status">
                  <option value="">Selecione uma situação</option>
                  <option *ngFor="let status of statusOptions" [value]="status.name">
                    {{ status.name }}
                  </option>
                </select>
                <small *ngIf="isViewMode" class="form-text text-muted">
                  Independente da situação de locação por contrato (B2B/B2C), exibida acima.
                </small>
              </div>
              <div class="detail-item">
                <label>Data de Compra</label>
                <input type="date" class="form-control" formControlName="purchaseDate" />
              </div>
              <div class="detail-item">
                <label>Preço de Compra</label>
                <input type="number" class="form-control" formControlName="purchasePrice" step="0.01" />
              </div>
              <div class="detail-item">
                <label>Localização Atual</label>
                <input class="form-control" formControlName="currentLocation" placeholder="Ex: São Paulo - SP" />
              </div>
              <div class="detail-item">
                <label>Código da Chave</label>
                <input class="form-control" formControlName="keyCode" maxlength="50" placeholder="Ex: CH-001" />
              </div>
            </div>
          </div>

          <!-- Seção 4: Observações -->
          <div class="detail-section">
            <h3><i class="fas fa-sticky-note me-2"></i> Observações</h3>
            <div class="detail-grid">
              <div class="detail-item full-width">
                <label>Observações</label>
                <textarea rows="4" class="form-control" formControlName="notes" placeholder="Ex: Veículo em excelente estado"></textarea>
              </div>
            </div>
          </div>
        </div>

        <!-- Tab: Anexos (novos uploads com tipo/tag; remoção só na edição) -->
        <div *ngIf="activeTab === 'attachments' && vehicleId" class="tab-panel">
          <div class="detail-section">
            <h3><i class="fas fa-paperclip me-2"></i> Anexos do Veículo</h3>
            <p class="text-muted small mb-3">
              Antes de enviar, escolha o <strong>tipo de documento</strong> e a <strong>tag</strong> (ex.: CRLV). A placa atual do cadastro é enviada como prefixo no upload.
            </p>
            <div class="row g-3 mb-2">
              <div class="col-md-6">
                <label class="form-label" for="vehicleDocType">Tipo de documento</label>
                <select
                  id="vehicleDocType"
                  class="form-select"
                  [(ngModel)]="selectedDocumentType"
                  [ngModelOptions]="{ standalone: true }">
                  <option *ngFor="let opt of documentTypeOptions" [ngValue]="opt.value">{{ opt.label }}</option>
                </select>
              </div>
              <div class="col-md-6">
                <label class="form-label" for="vehicleDocTag">Tag do arquivo</label>
                <select
                  id="vehicleDocTag"
                  class="form-select"
                  [(ngModel)]="selectedDocumentTag"
                  [ngModelOptions]="{ standalone: true }">
                  <option *ngFor="let opt of tagOptions" [ngValue]="opt.value">{{ opt.label }}</option>
                </select>
              </div>
            </div>
            <div class="row g-3 mb-3">
              <div class="col-12">
                <div
                  class="dropzone"
                  [class.dragover]="isDragOver"
                  (dragover)="onDragOver($event)"
                  (dragleave)="onDragLeave($event)"
                  (drop)="onDrop($event)">
                  <i class="fas fa-cloud-upload-alt"></i>
                  <div class="dz-text">
                    Arraste e solte arquivos aqui ou
                    <label for="vehicleFileInput" class="dz-browse"> clique para selecionar</label>
                  </div>
                  <input id="vehicleFileInput" type="file" (change)="onFileSelected($event)" multiple />
                </div>
              </div>
            </div>
            <div *ngIf="uploading" class="upload-progress mb-3">
              <div class="d-flex justify-content-between mb-2">
                <span>Enviando arquivo...</span>
                <span>{{ uploadProgress }}%</span>
              </div>
              <div class="progress">
                <div class="progress-bar" [style.width.%]="uploadProgress"></div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <div *ngIf="isLoadingAttachments" class="text-muted">Carregando anexos...</div>
                <div *ngIf="!isLoadingAttachments && (!attachments || attachments.length === 0)" class="text-muted">Nenhum anexo encontrado.</div>
                <div *ngIf="!isLoadingAttachments && attachments && attachments.length > 0" class="attachments-list">
                  <h5 class="mb-3">Arquivos Anexados</h5>
                  <div *ngFor="let att of attachments" class="attachment-item">
                    <div class="attachment-info">
                      <i class="fas fa-file attachment-icon"></i>
                      <div class="attachment-details">
                        <h6>{{ att.fileName }}</h6>
                        <small *ngIf="attachmentSubtitle(att) as sub" class="d-block text-muted">{{ sub }}</small>
                        <small>{{ formatAttachmentSize(att.fileSize) }}</small>
                      </div>
                    </div>
                    <div class="d-flex align-items-center">
                      <button
                        type="button"
                        class="btn btn-sm btn-outline-primary me-2"
                        title="Baixar"
                        (click)="downloadAttachment(att)">
                        <i class="fas fa-download"></i>
                      </button>
                      <input
                        #replaceInput
                        type="file"
                        class="d-none"
                        (change)="onReplaceFileSelected(att, $event)" />
                      <button
                        type="button"
                        class="btn btn-sm btn-outline-secondary me-2"
                        title="Substituir documento"
                        (click)="onReplaceAttachmentClick(att, replaceInput)">
                        <i class="fas fa-sync-alt"></i>
                      </button>
                      <button
                        type="button"
                        class="btn btn-sm btn-outline-danger"
                        title="Apagar documento"
                        (click)="removeAttachment(att)">
                        <i class="fas fa-trash"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Tab: Preventivas (somente quando o veículo já existe) -->
        <div *ngIf="activeTab === 'preventives' && vehicleId" class="tab-panel">
          <div class="detail-section">
            <h3><i class="fas fa-tools me-2"></i> Preventivas do Veículo</h3>

            <div *ngIf="preventivesError" class="alert alert-danger mb-3">
              {{ preventivesError }}
            </div>

            <div *ngIf="!preventivesError">
              <p class="text-muted mb-3" *ngIf="!isLoadingPreventives">
                Total de preventivas realizadas:
                <strong>{{ preventiveSummary?.totalPreventivesDone || 0 }}</strong>
              </p>

              <app-table
                [title]="'Histórico de preventivas'"
                [data]="preventiveHistoryTableData"
                [columns]="preventiveHistoryColumns"
                [loading]="isLoadingPreventives"
                [showSearch]="false"
                [clickable]="false"
                [disablePagination]="true">
              </app-table>

              <div
                *ngIf="!isLoadingPreventives && preventiveHistoryTableData.length === 0"
                class="text-muted mt-3">
                Nenhuma preventiva registrada para este veículo.
              </div>
            </div>
          </div>
        </div>

        <!-- Botões de ação -->
        <div class="form-navigation mt-4">
          <button type="button" class="btn btn-outline-secondary" (click)="cancel()">
            <i class="fas fa-arrow-left me-2"></i>
            Cancelar
          </button>
          <button
            *ngIf="!isViewMode"
            type="submit"
            class="btn btn-success"
            [disabled]="isSubmitting || form.invalid">
            <i class="fas fa-save me-2"></i>
            {{ isSubmitting ? 'Salvando...' : 'Salvar' }}
            <span *ngIf="isSubmitting" class="spinner-border spinner-border-sm ms-2"></span>
          </button>
        </div>
      </form>
    </div>
  </div>
</app-side-menu>
